import type { FC } from 'react';
import { Card, Grid, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import Title from 'src/components/admin/Title';
import TableCellHeaderGestion from 'src/components/global/TableCellHeaderGestion';
import Scrollbar from 'src/components/admin/Scrollbar';
import Loading from 'src/components/global/Loading';
import FunnelDetail from './FunnelDetail';

const FunnelGestion: FC<any> = ({ gestion, procesamiento, spinnerGestion, spinnerProcesamiento }) => (
  <>
    <Grid container spacing={2} mt={2}>
      <Grid item xl={12} md={12} xs={12}>
        <Title title="Funnel de Gestión y Procesamiento" align="left" />
      </Grid>
      <Grid item xl={12} md={12} xs={12}>
        <Card>
          <Scrollbar>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCellHeaderGestion>
                    Revisor(Ejecutivo Ventas) - Del mismo dia
                  </TableCellHeaderGestion>
                  <TableCellHeaderGestion width={100} align="right">
                    Operaciones Total
                  </TableCellHeaderGestion>
                  <TableCellHeaderGestion width={100} align="right">
                    Monto Total
                  </TableCellHeaderGestion>
                  <TableCellHeaderGestion width={150} align="right">
                    Dias Promedio en Estación/Estado
                  </TableCellHeaderGestion>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  spinnerGestion && (
                    <TableRow>
                      <TableCell colSpan={4}>
                        <Loading />
                      </TableCell>
                    </TableRow>
                  )
                }
                {
                  !spinnerGestion && gestion.map((item) => {
                    const keyGestion = `rowKeyGestion-${item.id}`;
                    return (
                      <FunnelDetail item={item} key={keyGestion} />
                    );
                  })
                }
              </TableBody>
            </Table>
          </Scrollbar>
        </Card>
      </Grid>
      <Grid item xl={12} md={12} xs={12}>
        <Card>
          <Scrollbar>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCellHeaderGestion>
                    Procesamiento - (Gestión Everis)
                  </TableCellHeaderGestion>
                  <TableCellHeaderGestion width={100} align="right">
                    Operaciones Total
                  </TableCellHeaderGestion>
                  <TableCellHeaderGestion width={100} align="right">
                    Monto Total
                  </TableCellHeaderGestion>
                  <TableCellHeaderGestion width={150} align="right">
                    Dias Promedio en Estación/Estado
                  </TableCellHeaderGestion>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  spinnerProcesamiento && (
                    <TableRow>
                      <TableCell colSpan={4}>
                        <Loading />
                      </TableCell>
                    </TableRow>
                  )
                }
                {
                  !spinnerProcesamiento && procesamiento.map((item, index) => {
                    const keyProcesamiento = `rowKeyProcesamient-${index}`;
                    return (
                      <FunnelDetail item={item} key={keyProcesamiento} />
                    );
                  })
                }
              </TableBody>
            </Table>
          </Scrollbar>
        </Card>
      </Grid>
    </Grid>
  </>
);

export default FunnelGestion;
